module.exports = __webpack_public_path__ + "img/rongyu_hk.3830471d.png";